export default "__VITE_ASSET__Cab_LRxb__"